import { PresetTemplate } from '../types';

export const EGYPT_REGIONS = [
  'القاهرة الجديدة / التجمع الخامس',
  'العاصمة الإدارية الجديدة',
  'الشيخ زايد / 6 أكتوبر',
  'مستقبل سيتي / الشروق',
  'الساحل الشمالي / رأس الحكمة',
  'العين السخنة',
  'الإسكندرية / سموحة والساحل',
  'الجونة / الغردقة',
  'المنصورة الجديدة / الصعيد',
  'دبي / الرياض (استهداف الخليج)'
];

export const PRESET_TEMPLATES: PresetTemplate[] = [
  {
    id: 'north-coast-ras-hekma',
    titleAr: 'شاليه رأس الحكمة - الساحل الشمالي',
    subtitleAr: 'استهداف المصطفيين والمستثمرين الخليجيين والمصريين',
    badge: 'الأعلى طلباً',
    data: {
      industry: 'real_estate',
      projectName: 'سولت رأس الحكمة - Salt Ras El Hekma',
      developerName: 'تطوير مصر - Tatweer Misr',
      propertyType: 'coastal_resort',
      region: 'الساحل الشمالي / رأس الحكمة',
      subArea: 'الكيلو 185 رأس الحكمة',
      unitType: 'شاليه 2 غرفة نوم صف ثاني على البحر مع لاجون',
      startingPrice: 6800000,
      currency: 'EGP',
      downPaymentPercent: 5,
      installmentYears: 8,
      deliveryYear: '2027',
      keyFeatures: [
        'صف أول وثاني على البحر مباشرة',
        'كريستال لاجون قابلة للسباحة',
        'مقدم 5% وأقساط على 8 سنوات بدون فوائد',
        'تشطيب كامل بالتكييفات',
        'منطقة تجارية ومطاعم عالمية'
      ],
      audienceType: 'luxury_vacation',
      dialectStyle: 'egyptian_colloquial',
      monthlyBudgetEGP: 35000
    }
  },
  {
    id: 'new-capital-admin',
    titleAr: 'مكتب إداري بالعاصمة الإدارية',
    subtitleAr: 'استهداف الأطباء، أصحاب الشركات، والمستثمرين بالمنطقة المركزية CBD',
    badge: 'عائد استثماري مرتفع',
    data: {
      industry: 'real_estate',
      projectName: 'تاج تاور - Tag Tower',
      developerName: 'شركة تاج مصر - Taj Misr',
      propertyType: 'commercial_admin',
      region: 'العاصمة الإدارية الجديدة',
      subArea: 'منطقة الأعمال المركزية CBD أمام البرج الأيقوني',
      unitType: 'مكتب إداري تشطيب كامل ومفروش بالكامل',
      startingPrice: 4200000,
      currency: 'EGP',
      downPaymentPercent: 10,
      installmentYears: 10,
      deliveryYear: '2026',
      keyFeatures: [
        'إطلالة مباشرة على البرج الأيقوني والنهر الأخضر',
        'عقد تفويض بالإيجار وإدارة عالمية',
        'مقدم 10% وأقساط مريحة على 10 سنوات',
        'قاعات اجتماعات ذكية وخدمات للشركات',
        'خصم خاص للكاش والشركات الكبرى'
      ],
      audienceType: 'egyptian_investor',
      dialectStyle: 'egyptian_colloquial',
      monthlyBudgetEGP: 25000
    }
  },
  {
    id: 'sheikh-zayed-villa',
    titleAr: 'تاون هاوس في الشيخ زايد',
    subtitleAr: 'استهداف العائلات المصرية والباحثين عن الرقي والهدوء',
    badge: 'سكن فاخر',
    data: {
      industry: 'real_estate',
      projectName: 'سوديك فيليت - Villette Zayed',
      developerName: 'سوديك - SODIC',
      propertyType: 'residential',
      region: 'الشيخ زايد / 6 أكتوبر',
      subArea: 'زايد الجديدة بالقرب من وصلة دهشور',
      unitType: 'تاون هاوس بحديقة خاصة ومساحة 220م2',
      startingPrice: 14500000,
      currency: 'EGP',
      downPaymentPercent: 5,
      installmentYears: 7,
      deliveryYear: '2026 (جاهز للتحميل قريبًا)',
      keyFeatures: [
        'مجتمع سكني مغلق كاملاً (Gated Community)',
        'كلوب هاوس وملاعب رياضية وحدائق واسعة',
        'قريب جداً من مول العرب ومحور 26 يوليو',
        'تسهيلات سداد حتى 7 سنوات',
        'أمن وحراسة كاميرات 24/7'
      ],
      audienceType: 'family_home',
      dialectStyle: 'egyptian_colloquial',
      monthlyBudgetEGP: 40000
    }
  },
  {
    id: 'fifth-settlement-apartment',
    titleAr: 'شقة سكنية بالتجمع الخامس',
    subtitleAr: 'استهداف المغتربين بالخليج والعائلات الشابة',
    badge: 'سريع البيع',
    data: {
      industry: 'real_estate',
      projectName: 'ماونتن فيو إي سيتي - Mountain View iCity',
      developerName: 'ماونتن فيو - Mountain View',
      propertyType: 'residential',
      region: 'القاهرة الجديدة / التجمع الخامس',
      subArea: 'التجمع الخامس بالقرب من الجولدن سكوير',
      unitType: 'شقة 165م2 (3 غرفة نوم + 2 حمام) بفيو على اللاندسكيب',
      startingPrice: 8900000,
      currency: 'EGP',
      downPaymentPercent: 10,
      installmentYears: 9,
      deliveryYear: '2026',
      keyFeatures: [
        'نظام بارك بدون سيارات بالنفق السفلي',
        'على بعد 5 دقائق من الجامعة الأمريكية AUC',
        'خصم حصري خلال فترة الطرح',
        'بحيرات صناعية ومسارات جاري ومناطق أطفال',
        'أقساط متساوية بدون دفعات استلام معقدة'
      ],
      audienceType: 'gulf_expat',
      dialectStyle: 'hybrid',
      monthlyBudgetEGP: 30000
    }
  },
  {
    id: 'ecommerce-skincare-offer',
    titleAr: 'عرض متجر عناية بالبشرة',
    subtitleAr: 'مبيعات مباشرة مع عرض واضح وتوصيل داخل مصر',
    badge: 'تجارة إلكترونية',
    data: {
      industry: 'ecommerce',
      projectName: 'باقة العناية اليومية',
      developerName: 'متجر نضارة',
      propertyType: 'residential',
      offerType: 'منتجات عناية بالبشرة أونلاين',
      region: 'مصر',
      subArea: 'القاهرة والجيزة والإسكندرية',
      unitType: 'باقة من ثلاثة منتجات للاستخدام اليومي مع دليل استخدام ودعم بعد الطلب',
      startingPrice: 1299,
      currency: 'EGP',
      downPaymentPercent: 0,
      installmentYears: 0,
      deliveryYear: '',
      keyFeatures: ['توصيل سريع', 'سياسة استبدال واضحة', 'دعم بعد الطلب'],
      audienceType: 'family_home',
      targetAudience: 'نساء ورجال مهتمون بروتين العناية اليومي والتسوق أونلاين داخل مصر',
      customerPainPoint: 'صعوبة اختيار روتين يومي بسيط ومنتجات متناسقة',
      promotionDetails: 'خصم على الباقة الكاملة لفترة محددة بوضوح في صفحة المنتج',
      conversionChannel: 'website',
      dialectStyle: 'egyptian_colloquial',
      monthlyBudgetEGP: 30000,
      campaignGoal: 'sales',
    }
  },
  {
    id: 'professional-accounting-service',
    titleAr: 'خدمة محاسبة للشركات الصغيرة',
    subtitleAr: 'جمع عملاء محتملين وحجز مكالمات استشارية',
    badge: 'خدمات مهنية',
    data: {
      industry: 'professional_services',
      projectName: 'باقة تنظيم الحسابات الشهرية',
      developerName: 'مكتب ميزان للاستشارات',
      propertyType: 'commercial_admin',
      offerType: 'خدمة محاسبة واستشارات مالية للشركات',
      region: 'مصر',
      subArea: 'القاهرة الكبرى والعمل عن بُعد',
      unitType: 'مراجعة وتنظيم الحسابات وإعداد تقارير شهرية مع اجتماع متابعة',
      startingPrice: 3500,
      currency: 'EGP',
      downPaymentPercent: 0,
      installmentYears: 0,
      deliveryYear: '',
      keyFeatures: ['تقارير شهرية واضحة', 'متابعة مع متخصص', 'خدمة أونلاين'],
      audienceType: 'business_medical',
      targetAudience: 'أصحاب الشركات الصغيرة والمتاجر الإلكترونية في مصر',
      customerPainPoint: 'عدم وضوح المصروفات والربحية وتأخر التقارير',
      promotionDetails: 'مكالمة تعريفية مجانية لتحديد نطاق الخدمة فقط',
      conversionChannel: 'calls',
      dialectStyle: 'modern_standard_arabic',
      monthlyBudgetEGP: 25000,
      campaignGoal: 'lead_generation',
    }
  },
  {
    id: 'education-online-course',
    titleAr: 'كورس تسويق رقمي أونلاين',
    subtitleAr: 'تسجيل دفعة جديدة بدون وعود توظيف غير واقعية',
    badge: 'تعليم وتدريب',
    data: {
      industry: 'education',
      projectName: 'برنامج أساسيات التسويق الرقمي',
      developerName: 'أكاديمية خطوة',
      propertyType: 'commercial_admin',
      offerType: 'برنامج تدريبي مباشر أونلاين',
      region: 'مصر ودول الخليج',
      subArea: 'متاح أونلاين',
      unitType: 'ثمانية أسابيع من المحاضرات المباشرة والتطبيقات العملية ومشروع تخرج',
      startingPrice: 4800,
      currency: 'EGP',
      downPaymentPercent: 0,
      installmentYears: 0,
      deliveryYear: '',
      keyFeatures: ['محاضرات مباشرة', 'تطبيقات عملية', 'تقييم وملاحظات على المشروع'],
      audienceType: 'business_medical',
      targetAudience: 'مبتدئون وأصحاب مشروعات يريدون فهم أساسيات التسويق الرقمي',
      customerPainPoint: 'تشتت مصادر التعلم وغياب التطبيق المنظم',
      promotionDetails: 'سعر تسجيل مبكر معلن حتى موعد محدد',
      conversionChannel: 'website',
      dialectStyle: 'hybrid',
      monthlyBudgetEGP: 30000,
      campaignGoal: 'lead_generation',
    }
  },
  {
    id: 'healthcare-dental-consultation',
    titleAr: 'حجوزات عيادة أسنان',
    subtitleAr: 'حملة مواعيد ملتزمة بخصوصية وسياسات المحتوى الصحي',
    badge: 'صحة وعيادات',
    data: {
      industry: 'healthcare',
      projectName: 'موعد تقييم أسنان',
      developerName: 'عيادة ابتسامة',
      propertyType: 'commercial_admin',
      offerType: 'حجز تقييم أولي في عيادة أسنان',
      region: 'القاهرة',
      subArea: 'نطاق 8 كم من الفرع',
      unitType: 'حجز موعد لتقييم الحالة وشرح الخيارات المتاحة بواسطة طبيب مختص دون ضمان نتيجة علاجية',
      startingPrice: 500,
      currency: 'EGP',
      downPaymentPercent: 0,
      installmentYears: 0,
      deliveryYear: '',
      keyFeatures: ['مواعيد منظمة', 'شرح واضح للخيارات', 'خصوصية بيانات المريض'],
      audienceType: 'business_medical',
      targetAudience: 'بالغون داخل النطاق الجغرافي للعيادة يبحثون عن خدمات أسنان عامة',
      customerPainPoint: 'الحاجة إلى تقييم واضح وخيارات مناسبة بعد الكشف',
      promotionDetails: 'سعر التقييم الأولي موضح بدون وعود علاجية',
      conversionChannel: 'whatsapp',
      dialectStyle: 'modern_standard_arabic',
      monthlyBudgetEGP: 35000,
      campaignGoal: 'bookings',
    }
  },
  {
    id: 'restaurant-family-meal',
    titleAr: 'عرض وجبة عائلية',
    subtitleAr: 'طلبات توصيل وزيارات فرع داخل نطاق محدد',
    badge: 'مطاعم وكافيهات',
    data: {
      industry: 'restaurants',
      projectName: 'الوجبة العائلية',
      developerName: 'مطعم المذاق',
      propertyType: 'commercial_admin',
      offerType: 'وجبة عائلية للطلب والتوصيل',
      region: 'القاهرة',
      subArea: 'نطاق التوصيل حول الفرع',
      unitType: 'وجبة تكفي أربعة أفراد مع أطباق جانبية ومشروبات موضحة في صفحة الطلب',
      startingPrice: 899,
      currency: 'EGP',
      downPaymentPercent: 0,
      installmentYears: 0,
      deliveryYear: '',
      keyFeatures: ['مكونات العرض واضحة', 'توصيل داخل النطاق', 'طلب مباشر وسريع'],
      audienceType: 'family_home',
      targetAudience: 'عائلات ومجموعات أصدقاء داخل نطاق التوصيل',
      customerPainPoint: 'اختيار وجبة مناسبة للمجموعة بسعر واضح',
      promotionDetails: 'العرض متاح خلال أيام وساعات محددة ومعلنة',
      conversionChannel: 'website',
      dialectStyle: 'egyptian_colloquial',
      monthlyBudgetEGP: 20000,
      campaignGoal: 'sales',
    }
  },
  {
    id: 'automotive-maintenance-package',
    titleAr: 'باقة صيانة سيارات',
    subtitleAr: 'حجوزات مركز خدمة مع شروط واضحة',
    badge: 'سيارات',
    data: {
      industry: 'automotive',
      projectName: 'باقة الصيانة الدورية',
      developerName: 'مركز أوتوكير',
      propertyType: 'commercial_admin',
      offerType: 'فحص وصيانة دورية للسيارات',
      region: 'القاهرة والجيزة',
      subArea: 'نطاق 15 كم من مركز الخدمة',
      unitType: 'فحص أساسي وتغيير زيت وفلتر وفق نوع السيارة مع تسعير نهائي بعد تأكيد البيانات',
      startingPrice: 1800,
      currency: 'EGP',
      downPaymentPercent: 0,
      installmentYears: 0,
      deliveryYear: '',
      keyFeatures: ['موعد مسبق', 'قطع ومستلزمات موضحة', 'تقرير فحص مختصر'],
      audienceType: 'business_medical',
      targetAudience: 'ملاك سيارات داخل النطاق الجغرافي لمركز الخدمة',
      customerPainPoint: 'تأخير الصيانة وعدم وضوح البنود المطلوبة',
      promotionDetails: 'سعر يبدأ من ويُحدد نهائيًا حسب نوع السيارة وحالتها',
      conversionChannel: 'calls',
      dialectStyle: 'egyptian_colloquial',
      monthlyBudgetEGP: 30000,
      campaignGoal: 'bookings',
    }
  },
  {
    id: 'tourism-weekend-stay',
    titleAr: 'إقامة نهاية أسبوع',
    subtitleAr: 'حجوزات فندقية بشروط وتواريخ واضحة',
    badge: 'سياحة وفنادق',
    data: {
      industry: 'tourism', projectName: 'باقة نهاية الأسبوع', developerName: 'فندق شاطئ النور', propertyType: 'coastal_resort',
      offerType: 'إقامة فندقية ليلتين', region: 'البحر الأحمر', subArea: 'الغردقة', unitType: 'إقامة ليلتين لشخصين تشمل الإفطار وفق التوفر والتواريخ المعلنة',
      startingPrice: 6500, currency: 'EGP', downPaymentPercent: 0, installmentYears: 0, deliveryYear: '', keyFeatures: ['إفطار مشمول', 'دعم للحجز', 'سياسة إلغاء واضحة'],
      audienceType: 'luxury_vacation', targetAudience: 'أزواج وعائلات داخل مصر يبحثون عن إجازة قصيرة', customerPainPoint: 'صعوبة مقارنة تفاصيل الإقامة وما يشمله السعر',
      promotionDetails: 'السعر متاح في التواريخ المحددة فقط', conversionChannel: 'website', fulfillmentDetails: 'تأكيد إلكتروني بعد مراجعة التوفر', scheduleDetails: 'عطلات نهاية الأسبوع خلال الشهر الحالي',
      trustSignals: 'بيانات الفندق وسياسة الإلغاء منشورة بوضوح', averageOrderValue: 6500, dialectStyle: 'hybrid', monthlyBudgetEGP: 40000, campaignGoal: 'bookings',
    }
  },
  {
    id: 'fitness-membership-trial',
    titleAr: 'اشتراك نادي رياضي',
    subtitleAr: 'عملاء محتملون وتجربة تعريفية بدون وعود نتائج',
    badge: 'لياقة ورياضة',
    data: {
      industry: 'fitness', projectName: 'اشتراك اللياقة الشهري', developerName: 'نادي حركة', propertyType: 'commercial_admin', offerType: 'اشتراك صالة رياضية وحصص جماعية',
      region: 'القاهرة', subArea: 'نطاق 7 كم من الفرع', unitType: 'دخول الصالة وحصص جماعية وفق الجدول مع جلسة تعريف بالأجهزة', startingPrice: 1400, currency: 'EGP',
      downPaymentPercent: 0, installmentYears: 0, deliveryYear: '', keyFeatures: ['جدول حصص متنوع', 'مدربون معتمدون', 'تجميد الاشتراك وفق الشروط'], audienceType: 'family_home',
      targetAudience: 'بالغون قريبون من الفرع مهتمون بنشاط رياضي منتظم', customerPainPoint: 'الحاجة إلى مكان قريب وجدول مرن', promotionDetails: 'زيارة تعريفية مجانية وفق الحجز',
      conversionChannel: 'whatsapp', fulfillmentDetails: 'تدريب داخل الفرع لجميع المستويات', scheduleDetails: 'يوميًا من 7 صباحًا إلى 11 مساءً', trustSignals: 'اعتمادات المدربين وشروط الاشتراك متاحة بالفرع',
      averageOrderValue: 1400, dialectStyle: 'egyptian_colloquial', monthlyBudgetEGP: 25000, campaignGoal: 'lead_generation',
    }
  },
  {
    id: 'mobile-app-subscription',
    titleAr: 'تطبيق إدارة مهام',
    subtitleAr: 'تسجيلات تجريبية لخدمة رقمية باشتراك واضح',
    badge: 'تطبيقات وخدمات رقمية',
    data: {
      industry: 'mobile_apps', projectName: 'تطبيق يومي لإدارة المهام', developerName: 'منصة إنجاز', propertyType: 'commercial_admin', offerType: 'تطبيق هاتف وخدمة اشتراك رقمية',
      region: 'مصر ودول الخليج', subArea: 'متاح رقميًا', unitType: 'تنظيم المهام والتذكيرات والتعاون المصغر عبر الهاتف والويب', startingPrice: 199, currency: 'EGP', downPaymentPercent: 0, installmentYears: 0,
      deliveryYear: '', keyFeatures: ['تجربة مجانية محددة', 'مزامنة بين الأجهزة', 'إلغاء الاشتراك بسهولة'], audienceType: 'business_medical', targetAudience: 'مستقلون وفرق صغيرة يريدون تنظيم العمل اليومي',
      customerPainPoint: 'تشتت المهام بين أدوات متعددة', promotionDetails: 'تجربة مجانية لمدة 14 يومًا ثم اشتراك شهري موضح', conversionChannel: 'website', fulfillmentDetails: 'متاح على الويب وiOS وAndroid',
      websiteUrl: 'https://example.com/app', scheduleDetails: 'تجربة 14 يومًا ودورة اشتراك شهرية', trustSignals: 'سياسة خصوصية ودعم فني وإلغاء ذاتي', averageOrderValue: 199,
      dialectStyle: 'modern_standard_arabic', monthlyBudgetEGP: 35000, campaignGoal: 'website_traffic',
    }
  }
];

// ملاحظة: بيانات مؤشر الأسعار وبنشمارك الـ CPL وسياسات Meta (صفحة "استراتيجيات CPL")
// بقت تُولَّد ديناميكياً بالذكاء الاصطناعي عبر GET /api/market-insights بدل ما تكون
// مثبتة هنا — شوف src/components/MarketInsights.tsx.
